

window.addEventListener('load', function() {
    const buyButtons = document.querySelectorAll('.shopify-payment-button__button, .product-form__submit'); // Finder både "Køb nu" og "Apple Pay"-knapper
    if (buyButtons.length === 0) return; // Hvis ingen knapper findes, stop

    const realBuyButton = buyButtons[0]; // Vælg den første knap (for eksempel "Køb nu")
    const stickyBuyButton = realBuyButton.cloneNode(true); // Kopier den første knap

    stickyBuyButton.classList.add('sticky-buy-button');
    document.body.appendChild(stickyBuyButton);

    // Stil knappen med CSS via JS
    Object.assign(stickyBuyButton.style, {
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        zIndex: '1000',
        backgroundColor: '#3A7D44', // Grøn farve
        color: '#fff',
        padding: '1em',
        textAlign: 'center',
        border: 'none',
        cursor: 'pointer',
        display: 'none', // Start med at være skjult
        pointerEvents: 'none', // Forhindrer klik før knappen er synlig
    });

    window.addEventListener('scroll', function() {
        const buttonBottom = realBuyButton.offsetTop + realBuyButton.offsetHeight;
        if (window.scrollY > buttonBottom) {
            stickyBuyButton.style.display = 'block'; // Vis knappen, når du scroller ned
            stickyBuyButton.style.pointerEvents = 'auto'; // Tillad klik, når knappen er synlig
        } else {
            stickyBuyButton.style.display = 'none'; // Skjul knappen, når du scroller op
            stickyBuyButton.style.pointerEvents = 'none'; // Forhindrer klik, når knappen er skjult
        }
    });

    stickyBuyButton.addEventListener('click', function() {
        realBuyButton.click(); // Simuler klik på den rigtige knap
    });
});



fetch(`/recommendations/products?product_id=12345&limit=3`)
    .then(response => response.json())
    .then(data => {
        let recommendationsHTML = '';
        data.products.forEach(product => {
            recommendationsHTML += `
                <div class="recommended-product">
                    <img src="${product.featured_image.url}" alt="${product.title}">
                    <p>${product.title}</p>
                    <p>${product.price}</p>
                </div>
            `;
        });
        document.getElementById('recommendations-container').innerHTML = recommendationsHTML;
    });


